
<template>
  <div class='complete-registration__container'>
    <img
      class="complete-registration__illustration"
      src="/images/registration/done–illustration.svg"
      alt="Sucesso"
    >
    <h1 class="complete-registration__text complete-registration__text--primary">
      Cadastro concluído com sucesso!
    </h1>

    <p class="complete-registration__text">
      {{ couponDescription }}
      <a href="/painel/gerenciar/cupons">{{ couponLink }}</a>
    </p>

    <div class="complete-registration__actions">
      <h2>
        <button
          class="button button--outline"
          @click="handleRedirect('/painel')"
        >
          ACESSAR O MELHOR ENVIO
        </button>
      </h2>

      <h2>
        <button
          class="button button--primary"
          @click="handleRedirect(documentsPageUrl)"
        >
          Verificar conta e aumentar limite
        </button>
      </h2>
    </div>
  </div>
</template>

<script>
import {scrollToTop} from 'commons/js/utils/scroll.js';
import {triggerAnalytics} from 'commons/js/utils/vendor.js'

export default {
  props: {
    email: {
      type: String,
      required: true
    }
  },

  mounted() {
    scrollToTop();
    this.checkCoupon();

    const {email} = this;
    this.triggerAnalytics({email});
  },

  data() {
    return {
      signUpCouponName: '',
      signUpCouponIsValid: false,
      signUpCouponCheckerLoading: false,
      documentsPageUrl: `${MEConfig.get('dash.url')}/documentos`
    }
  },
  methods: {
    triggerAnalytics,

    handleRedirect(path) {
      this.$emit('confirm');
      window.location.href = path;
    },

    async checkCoupon() {
      this.signUpCouponCheckerLoading = true;

      return await axios.post('/signup-coupon-checker')
      .then((response) => {
        this.signUpCouponName = response.data.name;
        this.signUpCouponIsValid = response.data.isValid;
      }).finally(() => {
        this.signUpCouponCheckerLoading = false;
      });
    }
  },
  computed: {
    couponDescription() {
        const baseDescription = 'Comece a economizar no frete agora mesmo.';

        if (this.signUpCouponCheckerLoading) {
          return baseDescription;
        }

        const signUpCouponDescription = 'Faça seus envios usando o cupom:';
        const defaultCouponDescription = `
          Faça seus primeiros 10 envios com 10% de desconto usando o cupom
        `;

        return `${baseDescription} ${this.signUpCouponIsValid ? signUpCouponDescription : defaultCouponDescription}`;
    },
    couponLink() {
      if (this.signUpCouponCheckerLoading) {
          return;
      }

      const defaultCouponName = 'MELHOR10EM10';

      return this.signUpCouponIsValid ? this.signUpCouponName : defaultCouponName;
    }
  }
}
</script>

<style lang="stylus" scoped>
.complete-registration

  &__container
    height 88vh
    width 96%
    margin 45px auto 0 auto
    display flex
    flex-flow column nowrap
    justify-content center
    align-content center
    align-items center

    @media screen and (min-width 500px)
      height 80vh
      width 80%
      margin 70px auto 0 auto

  &__illustration
    height 160px

    @media screen and (min-width 500px)
      height 200px

  &__text
    font-family 'Lato', sans-serif
    text-align center
    font-size 12px
    line-height 16px
    color #3B3F51
    max-width 236px
    margin 24px auto 0 auto

    @media screen and (min-width 500px)
      max-width 372px
      font-size 14px
      line-height 18px
      margin 18px auto 0 auto

    &--primary
      padding 0
      font-size 20px
      line-height 22px
      font-weight bold
      color #2BC866
      max-width 200px

      @media screen and (min-width 500px)
        max-width 372px
        font-size 22px
        line-height 24px

  &__actions
    display flex
    flex-direction column
    gap 16px
    align-items center
    justify-content center
    margin-top 32px
</style>
